export function setToLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error("Failed to write localStorage", error);
  }
}

export function getFromLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error("Failed to read localStorage", error);
    return null;
  }
}

export function removeFromLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Failed to remove localStorage", error);
  }
}
